import React from "react";

import { RouteComponentProps, Router } from "@reach/router";

import SpreadsheetImporter from "./interest_imports/components/main";
import Lottery from "./lottery";

const Importers: React.FC<RouteComponentProps> = () => (
  <Router primary={false}>
    <Lottery path="/lottery" />
    <SpreadsheetImporter path="/waitlist" />
  </Router>
);

export default Importers;
